<template>
  <img src="@/assets/img/campaign/startercp2023.jpg" />
</template>


<style scoped>
</style>

<script>
</script>